<template>
  <tr :class="classes" v-bind="$attrs">
    <slot />
  </tr>
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";

export interface TrProps {
  tableTarget?: "thead" | "tbody";
  zebra?: boolean;
  className?: Record<string, boolean> | string[] | string;
  active?: boolean;
}

const props = withDefaults(defineProps<TrProps>(), {
  tableTarget: "tbody",
  zebra: false,
  className: undefined,
  active: false,
});

const defaultStyles = {
  thead: "",
  tbody:
    "tw-border-b tw-border-primary-grey-100/80 tw-h-9 hover:tw-bg-primary-grey-25 dark:hover:tw-bg-primary-grey-100",
};

const { className, zebra, tableTarget, active } = toRefs(props);

const classes = computed(() => {
  const getBackgroundClass = () => {
    if (active.value) {
      return "tw-bg-primary-grey-200";
    }
    if (zebra.value) {
      return "tw-bg-primary-grey-50";
    }
    return "tw-bg-white";
  };

  const bg = getBackgroundClass();

  return [defaultStyles[tableTarget.value], bg, className.value];
});
</script>
